export default __webpack_public_path__ + "static/preview-1662574ceda5c47fa45b9014f06b95bf.jpg";